import React, { useContext, useEffect, lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// material ui
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import theme from '../theme';
import Axios from 'axios';

// components
// import Navbar from '../components/navbar/navbarComponent';
import GetStartedPage from '../pages/get-started-page/getStartedPage';
import AppHeader from '../components/app-header/AppHeader';
import GuestHomePage from '../pages/home-page/GuestHomePage';
import HomePage from '../pages/home-page/HomePage';
import AppFooter from '../components/app-footer/AppFooter';
import AboutUsPage from '../pages/about-us-page/AboutUsPage';
import NotFoundPage from '../pages/not-found-page/NotFoundPage';
import UesrContext from '../contexts/user-context/UserProvider';
import MyThemeContext from '../contexts/theme-context/ThemeProviderContext';
import pickBkgClass from '../utils/pickBkgClass';
import CreatePost from '../pages/create-post/CreatePost';
// import SinglePost from '../pages/single-post/SinglePost';
import FlashMessageContext from '../contexts/flash-messages-context/FlashMessageProvider';
import NotificationBar from '../common/NotificationBar';
import UserProfilePage from '../pages/user-profile-page/UserProfilePage';
import EditPost from '../pages/create-post/EditPost';
// import LiveChat from '../components/live-chat/LiveChat';
// import TermsPage from '../pages/terms-page/TermsPage';

import { LiveChatProvider } from '../contexts/live-chat-context/LiveChatProvider';
import Loading from '../common/loading/Loading';
// set the default base url for axios requests

const TermsPage = lazy(() => import('../pages/terms-page/TermsPage'));
const LiveChat = lazy(() => import('../components/live-chat/LiveChat'));
const SinglePost = lazy(() => import('../pages/single-post/SinglePost'));

// Axios.defaults.baseURL = 'http://localhost:8080';
Axios.defaults.baseURL =
	process.env.REACT_APP_BACKENDURL || 'https://socializebackend.herokuapp.com';

const App = () => {
	const { loggedIn, user, removeCurrentUser } = useContext(UesrContext);
	const { themeType, themeName } = useContext(MyThemeContext);
	const {
		flashMsgIsOpen,
		flashMsg,
		flashMsgDuration,
		notificationSeverity,
		handleFlashMsgClose,
		//
		setFlashMsgIsOpen,
		setFlashMsg,
		setFlashMsgDuration,
		setNotificationSeverity
	} = useContext(FlashMessageContext);

	// check if token expired or not in first render
	useEffect(() => {
		const cancelTokenSource = Axios.CancelToken.source();
		if (loggedIn) {
			const checkForValidToken = async () => {
				try {
					const response = await Axios.post(
						'/checkToken',
						{ token: user.token },
						{
							cancelToken: cancelTokenSource.token
						}
					);
					console.log('check for valid token', response);
					if (!response.data) {
						removeCurrentUser();
						setFlashMsgIsOpen(true);
						setFlashMsg('Please login again.');
						setFlashMsgDuration(4000);
						setNotificationSeverity('success');
					}
				} catch (e) {
					if (Axios.isCancel(e)) {
						console.log('Cought cancel');
					} else {
						throw e;
					}
				}
			};
			checkForValidToken();
		}
		return () => {
			cancelTokenSource.cancel();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ThemeProvider theme={theme(themeType, themeName)}>
			<MuiPickersUtilsProvider utils={MomentUtils}>
				<LiveChatProvider>
					<div
						className={`App ${themeType}App ${pickBkgClass(themeName, 'hard')}`}
					>
						<Suspense fallback={<Loading />}>
							<Switch>
								<Route exact path="/">
									{loggedIn ? (
										<Redirect from="/" to="/home" />
									) : (
										<GetStartedPage />
									)}
								</Route>

								<>
									<AppHeader />
									<Switch>
										{/* guest home page */}
										<Route
											exact
											path="/home"
											// render={() => (loggedIn ? <HomePage /> : <GuestHomePage />)}
										>
											{loggedIn ? <HomePage /> : <GuestHomePage />}
										</Route>
										{/* Profile page */}
										<Route exact path="/profile/:username">
											{loggedIn ? <UserProfilePage /> : <Redirect to="/home" />}
										</Route>
										{/* single post page */}
										<Route exact path="/post/:postId">
											{loggedIn ? <SinglePost /> : <Redirect to="/home" />}
										</Route>
										{/* Create post page */}
										<Route exact path="/createPost">
											{loggedIn ? <CreatePost /> : <Redirect to="/home" />}
										</Route>
										{/* Edit post page */}
										<Route exact path="/post/:postId/edit">
											{loggedIn ? <EditPost /> : <Redirect to="/home" />}
										</Route>
										{/* about us page */}
										<Route exact path="/about" component={AboutUsPage} />
										{/* Terms page */}
										<Route exact path="/terms" component={TermsPage} />
										{/* not found page */}
										<Route path="*" component={NotFoundPage} />
									</Switch>

									{loggedIn && <LiveChat />}
									<AppFooter />
								</>
							</Switch>
						</Suspense>
						{/* Flash messages */}
						<NotificationBar
							flashMsgIsOpen={flashMsgIsOpen}
							flashMsg={flashMsg}
							flashMsgDuration={flashMsgDuration}
							notificationSeverity={notificationSeverity}
							handleFlashMsgClose={handleFlashMsgClose}
						/>
					</div>
				</LiveChatProvider>
			</MuiPickersUtilsProvider>
		</ThemeProvider>
	);
};

export default App;
